import * as yup from 'yup';
import { SuggestionSchema } from '../../../common';

export const AdviceSheetSuggestionSchema = yup.object({
  fall: SuggestionSchema.nullable(),
  decubitus: SuggestionSchema.nullable(),
  physicalActivitySupport: SuggestionSchema.nullable(),
  nutrition: SuggestionSchema.nullable(),
  liquidSupply: SuggestionSchema.nullable(),
  continenceSupport: SuggestionSchema.nullable(),
  painManagement: SuggestionSchema.nullable(),
  chronicWoundManagement: SuggestionSchema.nullable(),
  intertrigoRisk: SuggestionSchema.nullable(),
  gerontopsychiatricImpairment: SuggestionSchema.nullable(),
  restrictingFreedomMeasuresHandling: SuggestionSchema.nullable(),
});

export type IAdviceSheetSuggestion = yup.InferType<typeof AdviceSheetSuggestionSchema>;
